/* @flow */
import Config from 'Config';
import { isEmpty } from 'lodash';
import QueryString from 'qs';
import xhr from 'xhr';

import { getCsrfTokenFromCookies, getCommonHeaders } from 'lib/requestHeaders';

export const remindXHR = { xhr };

function encodeData(data) {
  return QueryString.stringify(data, {
    arrayFormat: 'brackets',
  });
}

export default function remindWwwRequest(
  path: string,
  method: string = 'GET',
  data: Object = {},
  isJSON: boolean = true
): Promise<*> {
  const csrfToken = getCsrfTokenFromCookies();
  const urlParams = {};

  return new Promise(function(resolve, reject) {
    const options: Object = {
      url: `${Config.Environment.R101_FRONTEND_URL}${path}`,
      method,
      headers: {
        ...getCommonHeaders(csrfToken),
        'Content-Type': isJSON
          ? 'application/json; charset=utf-8'
          : 'application/x-www-form-urlencoded; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      timeout: 30 * 1000,
    };

    // XXX remove stores from API lib
    const CurrentUser = require('auth/CurrentUser').default;
    if (CurrentUser.getToken()) {
      urlParams['token'] = CurrentUser.getToken();
    } // This behavior is otherwise deprecated and should not be relied on.

    // always omit undefined
    // XXX We allow explicitly setting null to accomodate de-linking a class from an org. 💩
    for (const key in data) {
      if (data[key] === undefined || (method === 'GET' && data[key] === null)) {
        delete data[key];
      }
    }

    if (method === 'GET') {
      if (data) {
        Object.assign(urlParams, data);
        data = {}; // eslint-disable-line no-param-reassign
      }
    }

    if (!isEmpty(urlParams)) {
      options.url += '?' + encodeData(urlParams);
    }

    if (isJSON) {
      options.json = data;
    } else {
      options.body = encodeData(data);
    }

    remindXHR.xhr(options, function(err, response, body) {
      // A status code of `0` typically means that the xhr request was cancelled.
      // Don't handle these as they'll typically result in errors being produced.
      if (response.statusCode === 0) {
        return;
      }

      if (!isJSON) {
        try {
          body = JSON.parse(body); // eslint-disable-line no-param-reassign
        } catch (e) {
          // Do nothing.
        }
      }

      if (err || response.statusCode >= 400) {
        // TODO: Wrap the error response into something easier to use.
        if (body && typeof body === 'object') {
          body.statusCode = response.statusCode;
        }
        reject(err || body);
      } else {
        resolve(body);
      }
    });
  });
}
